import { call, put, takeEvery } from 'redux-saga/effects';
import { CREATE_TEST_FAILURE, CREATE_TEST_REQUEST, CREATE_TEST_SUCCESS, FETCH_USER_DATA_FAILURE, FETCH_USER_DATA_REQUEST, FETCH_USER_DATA_SUCCESS } from '../actions/dashboardActions';
import { USER_AUTH_STATUS_FAILURE } from '../actions/userActions';
import axiosInstance from '../api/axiosInstance';


// Worker Saga to fetch user data
function* fetchUserDataSaga() {
  try {
     // Make a request to fetch user data from the backend with token in headers
     const response = yield call(axiosInstance.get, "/dashboard");
    const userData = response.data;
    // Dispatch success action with user role
    yield put({ type: FETCH_USER_DATA_SUCCESS, payload: userData});
  } catch (error) {
    // Dispatch failure action on error
    if (error.response && error.response.status === 500) {
      // Redirect to login page
      yield put({ type: USER_AUTH_STATUS_FAILURE});

    } else {
      // Dispatch failure action on other errors
      yield put({ type: FETCH_USER_DATA_FAILURE, payload: { error: error.message } });
    }
  }
}





function* handelCreateTest(action) {
  try {
    
    const response = yield call(axiosInstance.post, "/createtest", action.payload);    
    if (response.data) {
      yield put({ type: CREATE_TEST_SUCCESS});

    }
  } catch (error) {
    yield put({ type: CREATE_TEST_FAILURE});
  }
}









// Watcher Saga to trigger fetch user data saga
function* fetchDashboardData() {
  yield takeEvery(FETCH_USER_DATA_REQUEST, fetchUserDataSaga);
  yield takeEvery(CREATE_TEST_REQUEST, handelCreateTest);

}

export default fetchDashboardData;
